import { Col as BaseCol } from 'antd'
import { styled } from 'styled-components'

export const Col = styled(BaseCol)`
  padding: ${({ theme }) => theme.spacers[3]};
`
